<template>
  <div class="page-content"  id="storeDetails">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/newStore'}">监控店铺</el-breadcrumb-item>
      <el-breadcrumb-item>监控详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <!-- 计划信息 -->
      <el-col :span="24" style="margin-bottom: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          计划信息
        </div>
      </el-col>
      <el-col :span="24">
        <el-card>

          <el-col :span="8">
            <div class="tenSize">
              <span class="fontColor">
                平台：
              </span>
              <span>
                {{hcmNewMonitorShop.platform | platformChinese}}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tenSize">
              <span class="fontColor">
                监控店铺：
              </span>
              <span>
                {{hcmNewMonitorShop.shopname}}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="twoSize">
              <span class="fontColor">
                监控时间：
              </span>
              <span>
                {{hcmNewMonitorShop.plathour}}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="twoSize">
              <span class="fontColor">
                计划状态：
              </span>
              <span v-if="hcmNewMonitorShop.status == 1">
                开启
              </span>
              <span v-else>
                关闭
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="twoSize">
              <span class="fontColor">
                通知人：
              </span>
              <span v-if="hcmNewMonitorShop.noticeusername">
                {{hcmNewMonitorShop.noticeusername}}
              </span>
              <span else>
                --
              </span>
            </div>
          </el-col>
        </el-card>
      </el-col>
      <!-- 监控数据概览 -->
      <el-col :span="24" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;float: left;">
          <div class="iconDiv">
            .
          </div>
          监控数据概览
        </div>
        <div style="float: right;">
          <span class="demonstration">监控时间：</span>
          <el-date-picker
            v-model="valuedata"
            type="date"
            placeholder="请选择选择"
            size="mini"
            @change="valueDataChange(1)">
          </el-date-picker>
          <el-select v-model="valueTime" placeholder="请选择" size="mini" @change="valueDataChange(2)">
            <el-option
              v-for="item in timeOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="24">
        <el-card style="padding: 0 20px 20px 20px;">
          <el-col :span="8">
            <div>
              <div style="color: #0000006d;">
                监控链接数
              </div>
              <div style="font-size: 24px;margin-top: 10px;">
                {{itemlinkNum}}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div>
              <div style="color: #0000006d;">
                正常链接数量
              </div>
              <div style="margin-top: 10px;width: 100%;">
                <div style="width: 50%;float: left;font-size: 24px;">
                  {{notlowpriceLink}}
                </div>
                <div style="width: 50%;float: right;font-size: 16px;margin-top: 10px;" v-if="pricePercentage">
                  {{pricePercentage.toFixed(2)}}%
                </div>
                <div style="width: 50%;float: right;font-size: 16px;margin-top: 10px;" v-else>
                  0%
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div>
              <div style="color: #0000006d;">
                违规链接数量
              </div>
              <div style="margin-top: 10px;width: 100%;">
                <div style="width: 50%;float: left;font-size: 24px;">
                  {{lowpriceLink}}
                </div>
                <div style="width: 50%;float: right;font-size: 16px;margin-top: 10px;" v-if="lowpricePercentage">
                  {{lowpricePercentage.toFixed(2)}}%
                </div>
                <div style="width: 50%;float: right;font-size: 16px;margin-top: 10px;" v-else>
                  0%
                </div>
              </div>
            </div>
          </el-col>
        </el-card>
      </el-col>
      <!-- 各平台监控链接链接情况 -->
      <el-col :span="8" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;float: left;">
          <div class="iconDiv">
            .
          </div>
          监控店铺链接情况分布
        </div>
        <div style="float: right;padding-right: 20px;font-size: 16px;cursor: pointer;">
          <i class="el-icon-document" @click="getLinkNumByLowprice2"></i>
          <i class="el-icon-download" style="padding-left: 20px;" @click="downloadLinkNumByLowprice"></i>
        </div>
      </el-col>
      <!-- 产品违规链接数量排名情况 -->
      <el-col :span="16" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;float: left;">
          <div class="iconDiv">
            .
          </div>
          产品违规链接数量排名情况
        </div>
        <div style="float: right;padding-right: 20px;font-size: 16px;cursor: pointer;">
          <i class="el-icon-document" @click="getLinkNumByProduct"></i>
          <i class="el-icon-download" style="padding-left: 20px;" @click="downloadLinkNumByProduct"></i>
        </div>
      </el-col>
      <el-col :span="8">
        <el-card style="margin-right: 20px;" v-loading="platformCharts4loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading">
          <div id="platformCharts4" :style="{width: '100%', height: '400px'}"></div>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card style="height: 440px;overflow-y:auto;">
          <el-table
             :data="productMap"
             style="width: 100%"
             height="400"
             v-loading="productMaploading"
             element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading">
               <el-table-column
               label="排名"
               type="index">
             </el-table-column>
             <el-table-column
               prop="productname"
               label="产品"
               min-width="70%">
             </el-table-column>
             <el-table-column
               prop="lowpriceNum"
               label="违规链接数"
               min-width="20%">
             </el-table-column>
           </el-table>
        </el-card>
      </el-col>
      <!-- 监控结果详情 -->
      <el-col :span="24" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          监控结果详情
        </div>
      </el-col>
    </el-row>
    <MonitorChildrenTable :paramsTime="childmonitortime" :paramsId='this.$route.query.id' ref="childrenTable"/>
  </div>
  <el-dialog title="数据详情" :visible.sync="byPlat" width="960px">
    <el-button @click="downloadLinkNumByLowprice" :loading="platformLoading" size="mini" style="margin-bottom: 8px;margin-top: 8px;margin-left: 4px;">下载数据</el-button>
    <div style="height: 647px;overflow: auto;">
      <el-table :data="byPlatData" style="margin-bottom: 60px;padding-left: 4px;padding-right: 4px;">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column property="name" label="监控结果"></el-table-column>
        <el-table-column property="proportion" label="占比"></el-table-column>
        <el-table-column property="num" label="链接量"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
  <el-dialog title="数据详情" :visible.sync="byProduct" width="960px">
    <el-button @click="downloadLinkNumByProduct" :loading="byProductLoading" size="mini" style="margin-bottom: 8px;margin-top: 8px;margin-left: 4px;">下载数据</el-button>
    <div style="height: 647px;overflow: auto;">
      <el-table :data="byProductData" style="margin-bottom: 60px;padding-left: 4px;padding-right: 4px;">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column property="productname" label="产品信息"></el-table-column>
        <el-table-column property="lowpriceNum" label="违规链接数"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</div>

</template>

<script>
import pagination from "../../../../components/dataTable/pagination";
import MonitorChildrenTable from "./MonitorChildrenTable";
import { pieOptionConfig } from "@/libs/echartOption/pieOption.js";

  export default {
    data() {
      return {
        platformCharts4loading: false,
        productMaploading: false,
        pricePercentage: '',
        lowpricePercentage: '',
        timeOptions: [],
        valuedata: '',
        valueTime: '',
        productMap: [],
        MonitorDaya: [],
        MonitorListByPlatform: [],
        platformArr: [],
        productlist: [],
        hcmNewMonitorShop: [],
        lowpriceLink: '',
        notlowpriceLink: '',
        monitortime: '',
        childmonitortime: '',
        itemlinkNum: '',
        byPlat: false,
        byProduct: false,
        byPlatData: [],
        byProductData: [],
        platformLoading: false,
        byProductLoading: false,
      }
    },
    mounted() {
      this.getShopMonitorDetail()

    },
    methods: {
      getLinkNumByProduct() {
        let params={
          planid: this.$route.query.id,
          monitortime: this.childmonitortime
        }
        fetch({
          url: "hcm/hcmShopMonitor/getLinkNumByProduct",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.byProductData = data
            this.compare(this.byProductData);
            this.byProduct = true
          }
        }).catch(err => {

        })
      },
      getLinkNumByLowprice() {
        this.platformCharts4loading = true
        let params={
          planid: this.$route.query.id,
          monitortime: this.childmonitortime
        }
        fetch({
          url: "hcm/hcmShopMonitor/getLinkNumByLowprice",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.byPlatData = data
            // this.byPlat = true
            // 环形图
            let newData = {
              价格正常: data[0],
              违规: data[1],
            }
            this.noAuthGroupByResult(newData);
            this.platformCharts4loading = false
          }
        }).catch(err => {

        })
      },
      getLinkNumByLowprice2() {
        this.byPlat = true
        this.getLinkNumByLowprice()
      },
      // 下载
      downloadLinkNumByLowprice() {
        this.platformLoading = true
        let params = {
          monitortime: this.childmonitortime,
          planid: this.$route.query.id,
        };
        fetch({
          url: "hcm/hcmShopMonitor/downloadLinkNumByLowprice",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "各平台监控链接链接.xlsx");
          document.body.appendChild(link);
          link.click();
          this.platformLoading = false
        });
      },
      // 下载
      downloadLinkNumByProduct() {
        this.byProductLoading = true
        let params = {
          monitortime: this.childmonitortime,
          planid: this.$route.query.id,
        };
        fetch({
          url: "hcm/hcmShopMonitor/downloadLinkNumByProduct",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "店铺违规链接数量排名.xlsx");
          document.body.appendChild(link);
          link.click();
          this.byProductLoading = false
        });
      },
      // 时间赋值
      valueDataChange(e) {
        if (e == 1) {
          this.monitortime = this.$options.filters['fullTime'] (this.valuedata).split(' ')[0]
          this.childmonitortime = this.$options.filters['fullTime'] (this.valuedata).split(' ')[0]
          this.valueTime = ''
          this.getHourByDate(this.monitortime)
        } else {
          this.monitortime = this.$options.filters['fullTime'] (this.valuedata).split(' ')[0] + ' ' + this.valueTime
          this.childmonitortime = this.$options.filters['fullTime'] (this.valuedata).split(' ')[0] + ' ' + this.valueTime
          this.$refs.childrenTable.pageData(this.monitortime);
          this.getShopMonitorDetail()
        }

      },
      // 数据源
      getShopMonitorDetail() {
        this.productMaploading = true
        let params={
          planid: this.$route.query.id,
        }
        if (this.monitortime) {
          params.monitortime = this.monitortime
        } else {
          params.monitortime = ''
        }
        fetch({
          url: "hcm/hcmShopMonitor/getShopMonitorDetail",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.productMaploading = false
            console.log(data)
            this.$refs.childrenTable.pageData(data.monitortime);
            this.MonitorDaya = data.MonitorPage
            this.lowpriceLink = data.lowpriceLink
            this.notlowpriceLink = data.notlowpriceLink
            this.itemlinkNum = data.itemlinkNum
            this.hcmNewMonitorShop = data.hcmNewMonitorShop
            if (data.hcmNewMonitorShop && data.hcmNewMonitorShop.platform) {
              this.platformArr = data.hcmNewMonitorShop.platform.split(',')
            }

            this.productlist =  data.productlist
            this.MonitorListByPlatform =  data.MonitorListByPlatform
            this.productMap = data.lowpriceProductList
            this.compare(this.productMap);

            // 时间
            this.valuedata = data.monitortime.split(' ')[0]
            this.valueTime = data.monitortime.split(' ')[1].substring(0,5)
            this.childmonitortime = data.monitortime
            let num = parseInt(data.notlowpriceLink) + parseInt(data.lowpriceLink)
            this.pricePercentage = parseInt(data.notlowpriceLink) / parseInt(num) * 100

            let num2 = parseInt(data.notlowpriceLink) + parseInt(data.lowpriceLink)
            this.lowpricePercentage = parseInt(data.lowpriceLink) / parseInt(num) * 100

            if (data.monitortime) {
              this.getHourByDate(data.monitortime)
            }
            this.getLinkNumByLowprice()
          }
        }).catch(err => {

        })
      },
      // 环形图
      noAuthGroupByResult(data) {
        console.log(data)
        let _this = this;
        let learnNum = data["价格正常"].num ? Number(data["价格正常"].num) : 0;
        let noticeNum = data["违规"].num ? Number(data["违规"].num) : 0;
        let total = learnNum + noticeNum;
        let seriesData = [
          {
            name: "价格正常",
            seriesData: [
              {
                name: "价格正常",
                value: learnNum,
                percentage: total ? ((learnNum / total) * 100).toFixed(2) : 0
              }
            ],
            graphic: this.getgraphic(),
            percent: true,
            center: ["50%", "30%"],
            radius: [80, 60]
          },
          {
            name: "违规",
            seriesData: [
              {
                name: "违规",
                value: noticeNum,
                percentage: total ? ((noticeNum / total) * 100).toFixed(2) : 0
              }
            ],
            center: ["50%", "80%"],
            radius: [80, 60]
          }
        ];
        this.$nextTick(() => {
          _this.platformCharts4 = _this.$echarts.init(
            document.getElementById("platformCharts4")
          );
          _this.platformCharts4.setOption(pieOptionConfig(seriesData),true);
        });
      },
      // 环形图
      getgraphic(total, text) {
        return [
          {
            type: "text",
            left: "27%",
            top: "40%",
            style: {
              text: total,
              fill: "#66666",
              fontSize: 32,
              fontWeight: "bold",
              textAlign: "center"
            }
          },
          {
            type: "text",
            left: "27%",
            top: "55%",
            style: {
              text: text ? text : "总数量",
              fill: "#666666",
              fontSize: 14,
              textAlign: "center"
            }
          }
        ];
      },
      //数组排序
      compare(arr) {
        var max;
        for(var i=0; i<arr.length; i++){
          for(var j=i; j<arr.length; j++){
            if(arr[i].lowpriceNum<arr[j].lowpriceNum){
              max=arr[j];
              arr[j]=arr[i];
              arr[i]=max;
            }
          }
        }
        return arr;
      },
      // 获取时间
      getHourByDate(time) {
        let params={
          planid: this.$route.query.id,
          monitortime: time.split(' ')[0]
        }
        fetch({
          url: "hcm/hcmShopMonitor/getHourByDate",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            console.log(data)
            this.timeOptions = data
          }
        }).catch(err => {

        })
      },
    },
    components: {
      pagination,MonitorChildrenTable
    }
  }
</script>
<style lang="scss">
  #storeDetails{
    .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }
    .page {
      padding: 20px;
      margin: 10px 0px 0px 0px;
      background-color: white;
    }

    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .iconDiv {
      width: 5px;
      background-color: #333333;
      margin-right: 10px;
      height: 21px;
      margin-top: 4px;
    }
    .fontColor {
      color: #000000a5;
    }
    .tenSize {
      height: 22px;
      margin-bottom: 10px;
    }
    .twoSize {
      height: 22px;
      margin-bottom: 20px;
    }

    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
  }
</style>
